import mainPageModel                      from '../main-navigation/MainPageModel';
import RuleSettingsEditorModel            from './RuleSettingsEditorModel';
import ToolbarButtons                     from './TimecardExporterRuleEditorButtons';

export default class TimecardExporterRuleEditorModel extends RuleSettingsEditorModel {
  constructor() {
    super('Timecard Exporter', 'kz3YRDsCuUOYMmAu1hzMXQ');
    this.ToolbarButtons = ToolbarButtons;
  }

  get access(): boolean {
    return mainPageModel.timecardExporterRulesAccess;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canEditTimecardExporterRules;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditTimecardExporterRules;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canEditTimecardExporterRules;
  }
}
